import React from 'react'
import makeToReact from '../utils/rehypeToReact'
import AElement from './AElement'

/** Converts Remark Markdown AST to a React element.  */
const renderAst = makeToReact({
  components: { a: AElement }
})

/**
 * Renders a Rehype AST using RehypeReact.
 *
 * See:
 * https://using-remark.gatsbyjs.org/custom-components/#enabling-the-component
 */

const MarkdownRenderer = ({ htmlAst }) => {
  return <>{renderAst(htmlAst)}</>
}

export default MarkdownRenderer
